'use strict';

const index = require('./index-4474431a.js');

const PlusIcon = () => (index.h("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", class: "plus-icon" },
  index.h("path", { d: "M14.6667 17.3333H8.00001C7.62223 17.3333 7.30556 17.2056 7.05001 16.95C6.79445 16.6944 6.66667 16.3778 6.66667 16C6.66667 15.6222 6.79445 15.3056 7.05001 15.05C7.30556 14.7944 7.62223 14.6667 8.00001 14.6667H14.6667V8.00001C14.6667 7.62223 14.7944 7.30556 15.05 7.05001C15.3056 6.79445 15.6222 6.66667 16 6.66667C16.3778 6.66667 16.6944 6.79445 16.95 7.05001C17.2056 7.30556 17.3333 7.62223 17.3333 8.00001V14.6667H24C24.3778 14.6667 24.6944 14.7944 24.95 15.05C25.2056 15.3056 25.3333 15.6222 25.3333 16C25.3333 16.3778 25.2056 16.6944 24.95 16.95C24.6944 17.2056 24.3778 17.3333 24 17.3333H17.3333V24C17.3333 24.3778 17.2056 24.6944 16.95 24.95C16.6944 25.2056 16.3778 25.3333 16 25.3333C15.6222 25.3333 15.3056 25.2056 15.05 24.95C14.7944 24.6944 14.6667 24.3778 14.6667 24V17.3333Z", fill: "currentColor" })));

const parseExcluded = (excluded) => excluded.split(";").map((item) => {
  const [column, values] = item.split(":");
  return {
    column,
    values: [values],
  };
});
const parseCampaigns = (campaigns) => campaigns.split(",").map((value) => {
  const trimmedValue = value.trim();
  return !isNaN(parseInt(trimmedValue))
    ? parseInt(trimmedValue)
    : trimmedValue;
});
const getRecommendationsBody = ({ productId, campaigns, color, excluded, dynamicFilters = [], }) => {
  const staticFilters = Object.assign(Object.assign({}, (color.length ? { color } : {})), (excluded.length ? { excluded: parseExcluded(excluded) } : {}));
  return Object.assign(Object.assign(Object.assign({ productId }, (dynamicFilters.length ? { dynamicFilters } : {})), (campaigns.length ? { campaigns: parseCampaigns(campaigns) } : {})), (Object.keys(staticFilters).length ? { staticFilters } : {}));
};
const getCustomLabels = (recommendation) => {
  const { custom_label_0, custom_label_1, custom_label_2, custom_label_3, custom_label_4, } = recommendation;
  return [
    custom_label_0,
    custom_label_1,
    custom_label_2,
    custom_label_3,
    custom_label_4,
  ]
    .filter((label) => label)
    .join(",");
};

exports.PlusIcon = PlusIcon;
exports.getCustomLabels = getCustomLabels;
exports.getRecommendationsBody = getRecommendationsBody;
